<template>
  <div>
    <b-row>
      <b-col>
        <div class="flex-column mt-4">
          <div class="d-flex justify-content-between align-items-center">
            <p>The following work orders have already passed from testing that are to be received</p>
            <div>
              <b-button size="sm" variant="primary" :disabled="selectedWO == 0 || isGettingInventories" @click="onShowPickList" class="mr-2">
                <i v-show="isGettingInventories" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                {{ isGettingInventories ? 'Getting' : '' }} Pick List
              </b-button>
            </div>
          </div>
        </div>
        <filters-component :filters="woToBeReceivedFilters" :keyNdx="1" @onSearch="getData"/>
        <work-orders-list
          :serviceOrdersParentList="woToBeReceivedList"
          :gridId="gridId"
          isParentList
          hideEdit
          @selectedServiceOrder="onSOSelect"
          @onSort="onSort"
          class="mt-1" />

      </b-col>
      <pick-list-modal
        isReceiving
        :pickTicketList="woInventoryForReceiving"
        :modalId="modalId"
        :serviceOrderId="selectedWO"
        @refreshData="getData"  />
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

/*import moment from 'moment';*/
import { DATE_FORMAT, GRID_ID } from '@/shared/constants';
import WorkOrdersList from '@/shared/components/ServiceOrders';
import PickListModal from '@/pages/ShippingReceiving/components/WorkOrdersTab/components/PickList';
/*import { filter } from 'minimatch';*/
/*import debounce from 'lodash/debounce';*/
import FiltersComponent from '../../components/Filters';

/*const PROCESS_DEBOUNCE_TIME = 750;*/

export default {
  components: {
    PickListModal,
    WorkOrdersList,
    FiltersComponent
  },
  data() {
    return {
      DATE_FORMAT,
      woToBeReceivedFilters: {},
      selectedWO: 0,
      listName: 'woToBeReceivedList',
      gridId: GRID_ID.WORK_ORDERS_TO_BE_RECEIVED,
      modalId: 'work-order-receiving-pick-list',
      isGettingInventories: false
    };
  },
  computed: {
    ...mapGetters('shippingReceiving', ['woToBeReceivedList', 'woInventoryForReceiving']),
  },
  methods: {
    ...mapActions('shippingReceiving', ['getWoToBeReceived', 'getInventoriesByServiceOrderId']),
    ...mapMutations('shippingReceiving', ['setItem']),
    async getData() {
      /*this.setList({ key: this.scheduleListName, value: [] });*/
      await this.getWoToBeReceived({
        filters: {
          ...this.woToBeReceivedFilters,
        }
      })

    },
    async onSOSelect($event) {
      this.isGettingInventories = true;
      this.selectedWO = $event.id;
      this.setItem({ resource: 'woInventoryForReceiving', payload: [] });
      await this.getInventoriesByServiceOrderId($event.id);
      this.isGettingInventories = false;
    },
    onShowPickList() {
      this.$bvModal.show(this.modalId);
    },
    onSort(evt) {
      this.setSortInfo({ ...evt, pageInfoState: 'woPageInfo' });
    }
  },
  watch: {
    woPageInfo() {
      this.getData()
    }
  },
  mounted() {
    this.setItem({ resource: this.listName, payload: [] });
    this.getData();
  }
};
</script>

<style scoped>
.sched-division {
    padding: 0.5rem;
    margin-top: 2rem;
}
</style>